import { useEffect, useRef } from 'react';
import Color from 'color';

const getDivBackgroundBrightness = (
  element: HTMLDivElement | null,
): number | null => {
  if (!element) {
    return null;
  }

  const computedStyle = getComputedStyle(element);
  return Color(computedStyle.backgroundColor).luminosity() * 255;
};

export const useAdjustTextContrast = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const brightness = getDivBackgroundBrightness(ref.current);
    if (brightness && brightness < 128) {
      ref.current.style.color = 'white';
    } else {
      ref.current.style.color = 'black';
    }
  }, [ref]);

  return ref;
};
